import { FC } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import { TraderGrantDto } from "../../api/Api";

type Props = {
  open: boolean;
  grant: TraderGrantDto | null;
  /** The book this grant belongs to, lowercase: "counterparty", "broker", "country". */
  entityLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
};

export const RevokeConfirmDialog: FC<Props> = ({
  open,
  grant,
  entityLabel,
  onCancel,
  onConfirm,
  isSubmitting
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogTitle>Revoke access?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        <strong>{grant?.displayName}</strong> will lose access to this{" "}
        {entityLabel}. You can grant it again later.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={isSubmitting}>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        color="error"
        variant="contained"
        disabled={isSubmitting}
      >
        {isSubmitting ? "Revoking..." : "Revoke"}
      </Button>
    </DialogActions>
  </Dialog>
);
